<template>
  <AppContentPage class="content-group-detail-view"/>
</template>

<script setup lang="ts">

</script>
